var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbsup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "100%",
    width: "100%",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.336.55l.095.003c1.391.069 2.681 1.296 2.445 2.992l-1.684 6.975h8.386c2.286 0 3.928 2.24 3.28 4.476l-1.561 11.697c-.363 2.723-2.644 4.753-5.338 4.753H9.93V12.265c0-.367.111-.707.299-.988l7.216-9.872c.517-.574 1.16-.836 1.795-.854l.095-.001zM4.966 11.584c.91 0 1.655.689 1.655 1.528v16.805c0 .841-.745 1.529-1.655 1.529h-3.31c-.91 0-1.656-.688-1.656-1.529V13.112c0-.84.746-1.528 1.656-1.528zm13.786-9.107l-.013.012-7.113 9.732-.007.016-.004.028v17.497h13.344c1.8 0 3.341-1.334 3.648-3.157l.02-.135 1.577-11.821.035-.121c.33-1.134-.46-2.257-1.564-2.32l-.097-.003H18.054l2.16-8.952.002-.023c.052-.81-.832-1.265-1.407-.803zM4.936 13.269H1.684v16.493h3.252z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsup);
export default __webpack_public_path__ + "static/media/thumbsup.ebfa09b470bc25ab66cc3f5b542d8ab0.svg";
export { ForwardRef as ReactComponent };